import { render, staticRenderFns } from "./FeaturedSchool.vue?vue&type=template&id=7e0a429b&scoped=true&"
import script from "./FeaturedSchool.vue?vue&type=script&lang=js&"
export * from "./FeaturedSchool.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedSchool.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./FeaturedSchool.vue?vue&type=style&index=1&id=7e0a429b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0a429b",
  null
  
)

export default component.exports